import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';
import { PatientRegistration } from '../patient-services/patient-registration';
import { VaccineSetting } from './vaccinesetting';

export interface VaccineTransactionParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface VaccineTransaction {
    id?: any;
    regId: any;
    vaccineId: any;
    planned_Date: any;
    injection_Date: any;
    injection_Status: string;
    vaccine_Done_From_Our_Hospital:string;
    others_Location_Det:string;
    notes:string;
    tenantId: any;
    branchId: any;

    vaccineSetting?: VaccineSetting;
    PatientRegistration?: PatientRegistration;
    parameters?: VaccineTransactionParameter[];
    links?: any;
}

export abstract class VaccineTransactionData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<VaccineTransaction[]>;
    abstract create(url: string, data: any): Observable<VaccineTransaction[]>;
    abstract update(url: string, data: VaccineTransaction): Observable<VaccineTransaction>;
    abstract delete(url: string): Observable<any>;
}
